export default __webpack_public_path__ + "static/media/a012-market-line-7.75a9d21f.svg";